import { FIELD_COMPONENT_TYPES } from '@wix/forms-common'

export const EXTRA_COLSPANS = {
  [FIELD_COMPONENT_TYPES.TEXT_AREA_INPUT]: 2,
  [FIELD_COMPONENT_TYPES.CHECKBOX_GROUP]: 1,
  [FIELD_COMPONENT_TYPES.RADIO_GROUP]: 1,
  [FIELD_COMPONENT_TYPES.COMPLEX_FIELD_WIDGET]: 2,
}
